// AI Upgraded Component
import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ExtensionService } from '../../services/extension.service';

@Component({
    selector: 'extension-guide-panel',
    templateUrl: './extension-guide-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ExtensionGuidePanelComponent implements OnInit {
    currentExtension: any;

    constructor (
        @Inject(ExtensionService) private extensionService: ExtensionService,
    ) {}

    ngOnInit (): void {
        this.currentExtension = this.extensionService.getCurrentExtensionInfo();
    }
}
